import React, { useState } from "react";
import Footer from "../Common/Footer";
import Header from "../Common/Header";
import { Link } from "react-router-dom";

function Contact() {
  //https://crm.smartuworld.com/mobile/WebContact?name=anuj&email=anuj04@gmail.com&mobile=8445989182&subjecttext=testafaffa&messagetext=theradrt&optdndtag=opttagyes&customerpartner=testpartner&acceptprivacytag=accepttag
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    subjecttext: "",
    customerpartner: "", // Default selection for visit type
    messagetext: "",
    optdndtag: false,
    Product:"",
    acceptprivacytag: false,
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(""); // State to store the selected value

  const handleProductChange = (event) => {
    setSelectedProduct(event.target.value); // Update state when an option is selected
  };
  // Handle input changes
  const handleChange = (e) => {
    debugger;
    const { name, value, type, checked } = e.target;

    if (name === "Product") {
      setSelectedProduct(value); 
      setFormData({
        ...formData,
        [name]: value,
      });
      return;
    }
    if (name === "optdndtag") {
      setFormData({
        ...formData,
        [name]: "opttagyes",
      });
      return;
    }
    if (name === "acceptprivacytag") {
      setFormData({
        ...formData,
        [name]: "accepttag",
      });
      return;
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };
  const validateForm = () => {
    const { name, email, mobile, subjecttext, messagetext, optdndtag, acceptprivacytag } = formData;
    let errorMessage = "";

    // Check for required fields
    if (!name || !email || !mobile || !subjecttext || !messagetext) {
      errorMessage = "Please fill all the required fields.";
    }

    // Email validation
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (email && !emailRegex.test(email)) {
      errorMessage = "Please enter a valid email address.";
    }

    // Phone number validation (10 digits)
    const phoneRegex = /^[0-9]{10}$/;
    if (mobile && !phoneRegex.test(mobile)) {
      errorMessage = "Please enter a valid 10-digit phone number.";
    }

    // Checkbox validation
    if (!optdndtag || !acceptprivacytag) {
      errorMessage = "You must agree to the terms and privacy policy.";
    }

    if (errorMessage) {
      setErrorMessage(errorMessage);
      return false;
    }

    return true;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    debugger;
    e.preventDefault();
    if (!validateForm()) {
      return; // Don't proceed if validation fails
    }
    fetch("https://crm.smartuworld.com/mobile/WebContact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data?.status) {
          alert(data?.message);
          setFormData({
            name: "",
            email: "",
            mobile: "",
            subjecttext: "",
            customerpartner: "",
            messagetext: "",
            optdndtag: false,
            Product: "",
            acceptprivacytag: false,
          });
        }
      })
      .catch((error) => {
        alert("Try after some time");
        console.error("Error:", error);
      });
  };
  return (
    <>
      <Header />
      {/* Start Contact Us Area  */}
      {/* Start Contact Card Area */}
      <div className="contact-area">
        <div className="container">
          <div className="contact-card-item contact-card-items">
            <div className="row justify-content-center">
              <div className="col-lg-4 col-sm-6 col-md-6">
                <div className="contact-card">
                  <div className="contact-icon">
                    <img src="assets/images/icons/tollfree.svg" alt="Phone" />
                  </div>
                  <h2>Phone Number</h2>
                  <h2>+91-9355200600</h2>

                  <p>
                    Our customer service experts are here for you. Lines are
                    open Mon-Sat from 9:30 am – 6:30 pm
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6 col-md-6">
                <div className="contact-card">
                  <div className="contact-icon">
                    <img src="assets/images/icons/email.svg" alt="Email" />
                  </div>
                  <h2>Sent Us Email</h2>
                  <h2>info@smartuworld.com</h2>

                  <p>
                    {" "}
                    For queries related to loans, credit cards or in case of any
                    general enquiries.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6 col-md-6">
                <div className="contact-card">
                  <div className="contact-icon">
                    <img
                      src="assets/images/icons/location.svg"
                      alt="Location"
                    />
                  </div>
                  <h2>Our Location</h2>
                  <h2>6146/7, D-6 , Vasant Kunj, Delhi - 110070 India</h2>

                  <p>
                    In case your concern is not resolved, you can contact our
                    Office.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Contact Card Area */}

      <div className="contact-us-area pt-370 pb-100 bgcolor">
        <div className="container">
          <div className="section-title">
            <span className="top-title">Get In Touch</span>
            <h2>Fill In The Contact Now</h2>
          </div>
          <div className="row">
            {/* <div className="col-lg-6">
              <div className="single-contact-img">
                <div className="contact-main-img">
                  <img
                    src="assets/images/contact-us-img-5.webp"
                    alt="contact-us"
                  />
                </div>
                <div className="contact-us-img1">
                  <img
                    src="assets/images/contact-us-img-1.webp"
                    alt="contact-us"
                  />
                </div>
                <div className="contact-us-img2">
                  <img
                    src="assets/images/contact-us-img-2.webp"
                    alt="contact-us"
                  />
                </div>
                <div className="contact-us-img3">
                  <img
                    src="assets/images/contact-us-img-3.webp"
                    alt="contact-us"
                  />
                </div>
                <div className="contact-us-img4">
                  <img
                    src="assets/images/contact-us-img-4.webp"
                    alt="contact-us"
                  />
                </div>
                <div className="contact-main-image1s">
                  <img
                    src="assets/images/contact-main-bg-img.webp"
                    alt="main"
                  />
                </div>
              </div>
            </div> */}
            <div className="col-lg-12">
              <div className="contact-form">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-lg-4 col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          id="name"
                          className="form-control"
                          placeholder="Name"
                          required=""
                          data-error="Please enter your name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                        <div className="help-block with-errors" />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Your Email"
                          required=""
                          data-error="Please enter your email"
                        />
                        <div className="help-block with-errors" />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          id="phone_number"
                          name="mobile"
                          value={formData.mobile}
                          onChange={handleChange}
                          placeholder="Phone"
                          required=""
                          data-error="Please enter your number"
                          className="form-control"
                        />
                        <div className="help-block with-errors" />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="form-group">
                        <select name="Product" className="form-control" value={selectedProduct}
                          onChange={handleChange} >
                          <option value="">Select Product</option>
                          <option value="Credit Cards">Credit Cards</option>
                          <option value="Bank Accounts">Bank Accounts</option>
                          <option value="Personal Loan">Personal Loan</option>
                          <option value="Housing Loan">Housing Loan</option>
                          <option value="Business Loan">Business Loan</option>
                          <option value="Professional Loan">Professional Loan</option>
                          <option value="Gold Loan">Gold Loan</option>
                          <option value="Vehicle Loan">Vehicle Loan</option>
                          <option value="Micro Loan">Micro Loan</option>
                          <option value="Motor Insurance">Motor Insurance</option>
                          <option value="Life Insurance">Life Insurance</option>
                          <option value="Health Insurance">Health Insurance</option>
                          <option value="Group Insurance">Group Insurance</option>
                          <option value="Aeps">Aeps</option>
                          <option value="Bbps">Bbps</option>
                          <option value="Recharges">Recharges</option>
                          <option value="Dmts">Dmts</option>
                          <option value="Passport">Passport</option>
                          <option value="Marriage Certificate">Marriage Certificate</option>
                          <option value="Driving License">Driving License</option>
                          <option value="Caste Certificate">Caste Certificate</option>
                          <option value="Income Certificate">Income Certificate</option>
                          <option value="Domicile Certificate">Domicile Certificate</option>
                          <option value="Birth Certificate">Birth Certificate</option>
                        </select>


                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          id="Subject"
                          name="subjecttext"
                          value={formData.subjecttext}
                          onChange={handleChange}
                          placeholder="Subject"
                          required=""
                          data-error="Please enter your subject"
                          className="form-control"
                        />
                        <div className="help-block with-errors" />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="form-group">

                        <div style={{ marginTop: 10 }}>
                          <input
                            type="radio"
                            id="partner"
                            name="customerpartner"
                            value="Partner"
                            checked={formData.customerpartner === "Partner"}
                            onChange={handleChange}
                          />
                          <label for="partner">As a Partner</label>
                          <input
                            type="radio"
                            id="customer"
                            name="customerpartner"
                            value="Customer"
                            checked={formData.customerpartner === "Customer"}
                            onChange={handleChange}
                            style={{ marginLeft: 20 }}
                          />
                          <label for="customer">As a Customer</label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <textarea
                          name="messagetext"
                          value={formData.messagetext}
                          onChange={handleChange}
                          type="text"
                          className="form-control"
                          id="message"
                          cols={30}
                          rows={2}
                          placeholder="Message"
                          required=""
                          data-error="Write your message"
                          defaultValue={""}
                        />
                        <div className="help-block with-errors" />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <div className="form-check">
                          <input
                            name="optdndtag"
                            checked={formData.optdndtag}
                            onChange={handleChange}
                            defaultValue=" I authorize SmartuWorld and its representative to contact me with updates and notifications via Email, SMS, Whatsapp and call, This will override the registry on DND/NDNC."
                            className="form-check-input"
                            type="checkbox"
                            id="authorize"
                            required="required"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="authorize"
                          >
                            I authorize SmartuWorld and its representative to
                            contact me with updates and notifications via Email,
                            SMS, Whatsapp, Call and RCS, This will override the
                            registry on DND/NDNC.
                          </label>
                          <div className="help-block with-errors gridCheck-error" />
                        </div>
                      </div>
                      <div className="form-group">
                        <div className="form-check">
                          <input
                            name="acceptprivacytag"
                            defaultValue="I agree to the terms and privacy policy."
                            className="form-check-input"
                            type="checkbox"
                            id="gridCheck"
                            required="required"
                            checked={formData.acceptprivacytag}
                            onChange={handleChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="gridCheck"
                          >
                            Accept{" "}
                            <Link to="/terms">
                              Terms Of Services
                            </Link>{" "}
                            and <Link to="/privacy">privacy policy</Link>
                          </label>
                          <div className="help-block with-errors gridCheck-error" />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12">
                      <button type="submit" className="default-btn">
                        Submit Now
                      </button>
                      {errorMessage && (
                        <div className="text-danger">{errorMessage}</div>
                      )}
                      {successMessage && (
                        <div className="text-success">{successMessage}</div>
                      )}
                      <div id="msgSubmit" className="h3 text-center hidden" />
                      <div className="clearfix" />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Contact Us Area  */}

      {/* Start Map Area */}
      <div className="map-area">
        <div className="container-fluid">
          <div className="place-map">
            <iframe
              className="maps"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3505.4318433698436!2d77.14721817428908!3d28.526736888879338!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1dd53fa97d0b%3A0xad3d8a46e7c680f9!2s6146%2C%20Pocket%206%2C%20Sector%20D%2C%20Vasant%20Kunj%2C%20New%20Delhi%2C%20Delhi%20110070!5e0!3m2!1sen!2sin!4v1734087492248!5m2!1sen!2sin"
            />
          </div>
        </div>
      </div>
      {/* End Map Area */}

      <Footer />
    </>
  );
}

export default Contact;
